.scrollable {
  overflow-x: auto;
  scrollbar-width: none;
}

.scrollable::-webkit-scrollbar {
  display: none;
}

.scroller {
  display: inline-block;
  position: relative;
  flex: 1 1 auto;
  white-space: nowrap;
}
